import PortailAffectationListController from './affectation.list.controller';

export default {
    controller: PortailAffectationListController,
    template: require('./affectation.list.tpl.html')
};
